'use client'

import { ReactElement } from 'react'

import { useLegalLinks } from '@/hooks/useLegalLinks'
import { Link } from '@/i18n/navigation'

export default function LegalLinksList(): ReactElement {
    const legalLinks = useLegalLinks()

    return (
        <ul>
            {legalLinks.map(link => (
                <li key={link.href}>
                    <Link href={link.href}>{link.title}</Link>
                </li>
            ))}
        </ul>
    )
}
